import { render, staticRenderFns } from "./CustomerHubPreferenceSwitch.vue?vue&type=template&id=0b98efcc&scoped=true"
import script from "./CustomerHubPreferenceSwitch.vue?vue&type=script&lang=js"
export * from "./CustomerHubPreferenceSwitch.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubPreferenceSwitch.vue?vue&type=style&index=0&id=0b98efcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98efcc",
  null
  
)

export default component.exports